import { FC, useMemo } from 'react';
import { Text } from '@weave/design-system';
import { Category, CategoryOption } from '@forms-exp/types';
import { contentStyle, titleStyle, containerStyle } from './category-review.style';

const DEFAULT_OPTIONS: CategoryOption[] = [];

interface CategoryReviewProps {
  category: Category;
  selectedOptions: string[];
}

const CategoryReview: FC<CategoryReviewProps> = ({
  category: { id, name, options = DEFAULT_OPTIONS },
  selectedOptions,
}) => {
  const selectedOptionsUnderCategory = useMemo<string>(() => {
    const _selectedOptions = options.filter(
      ({ value }) => value && selectedOptions.includes(value)
    );
    return _selectedOptions.length
      ? _selectedOptions.map((o) => o.label).join(', ')
      : '-';
  }, [selectedOptions, options]);

  return (
    <div css={containerStyle}>
      <Text weight="regular" css={titleStyle}>
        {name}
      </Text>
      <Text weight="bold" css={contentStyle}>
        {selectedOptionsUnderCategory}
      </Text>
    </div>
  );
};

export default CategoryReview;
